<template>
  <div class="beijing">
    <div class="denglu" >
      <el-tabs style="width: 100%" stretch type="border-card">
        <el-tab-pane style="padding: 2rem 2rem 1rem 2rem">
          <span slot="label"><i class="el-icon-date"></i>登录</span>
          <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <el-form-item prop="user">
              <el-input placeholder="用户电话号码" type="username" v-model="ruleForm.user" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item prop="pwd">
              <el-input placeholder="密码" type="password" v-model="ruleForm.pwd" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="login">登录</el-button>
              <el-button style="margin-left: 3rem" @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="注册" style="padding: 2rem 2rem 1rem 2rem">
          <el-form
                  name="custom-validation"
                  ref="formRegiser"
                  :model="formRegiser"
                  :rules="rulesRegiser"
                  @finish="regiserFinish"
          >
            <el-form-item  name="use_phone" prop="use_phone">
              <el-input v-model:value="formRegiser.use_phone" placeholder="请输入电话号码" autocomplete="off" />
            </el-form-item>
            <el-form-item name="code" prop="code">
              <el-row>
                <el-col :span="12">
                  <el-input style="width: 15rem" v-model:value="formRegiser.code" placeholder="请输入验证码" autocomplete="off" />
                </el-col>
                <el-col :span="12">
                  <el-button v-if="!codeNum" type="primary" @click="code" style="margin-left:2rem">获取验证码</el-button>
                  <span v-if="codeNum" class="code">
                <span style="color: #409EFF;font-size: 1.8rem;font-weight: bolder"><i>{{String(codeNum)[0]}}</i></span>&nbsp;
                <span style="color: #ff154c;font-size: 1.8rem;font-weight: bolder"><i>{{String(codeNum)[1]}}</i></span>
                <span style="color: #ff9001;font-size: 1.8rem;font-weight: bolder"><i>{{String(codeNum)[2]}}</i></span>
                <span style="color: #409EFF;font-size: 1.8rem;font-weight: bolder"><i>{{String(codeNum)[3]}}</i></span>
              </span>
                </el-col>
              </el-row>

            </el-form-item>
            <el-form-item :rules="[{ required: true, message: '昵称不能为空'},]" name="username" prop="username">
              <el-input v-model:value="formRegiser.username" placeholder="请输入昵称"  autocomplete="off" />
            </el-form-item>
            <el-form-item  name="pass" prop="pass">
              <el-input v-model:value="formRegiser.pass" placeholder="请输入密码" type="password" autocomplete="off" />
            </el-form-item>
            <el-form-item name="checkPass" prop="checkPass">
              <el-input v-model:value="formRegiser.checkPass" placeholder="请再次确认密码" type="password" autocomplete="off" />
            </el-form-item>
            <el-form-item :wrapper-col="{ span: 14, offset: 4 }">
              <el-button type="primary" @click="submitForm('formRegiser')">注册</el-button>
              <el-button @click="resetForm('formRegiser')">重置</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  import utils from "../utils/utils";
  export default {
    name:'Login',
    data() {
      var validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入用户电话号码'));
        } else {
          if(!(/^1\d{10}$/.test(value))){
            callback(new Error('请输入正确的电话号码格式'));
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          callback();
        }
      };
      var validatePassRegiser = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.formRegiser.checkPass !== '') {
            this.$refs.formRegiser.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePassRegiser2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.formRegiser.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      var validateCodeRegiser = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入验证码'));
        } else if ( !this.codeNum) {
          callback(new Error('请先获取验证码!'));
        } else if (value !== String(this.codeNum)) {
          callback(new Error('验证码错误!'));
        } else {
          callback();
        }
      };

      return {
        ruleForm: {
          user: '',
          pwd: '',
        },
        formRegiser:{
          use_phone: '',
          username: '',
          code: '',
          pass: '',
          checkPass: '',
        },
        rules: {
          user: [
            { validator: validatePhone, trigger: 'blur' }
          ],
          pwd: [
            { validator: validatePass2, trigger: 'blur' }
          ],
        },
        rulesRegiser : {
          use_phone: [{validator: validatePhone, trigger: 'blur'}],
          pass: [{validator: validatePassRegiser, trigger: 'blur'}],
          checkPass: [{validator: validatePassRegiser2, trigger: 'blur'}],
          code: [{validator: validateCodeRegiser, trigger: 'change'}],
        },
        codeNum:null
      }
    },
    methods: {
      login(){
        this.axios({
          url:'/userLogin',
          method:'post',
          data:{
            psw:this.ruleForm.pwd,
            user_phone:this.ruleForm.user
          }
        }).then(data=>{
          if (data.data.code === 200){
            this.$message({
              message:data.data.message,
              type: 'success'
            });
            utils.setStorage('user',data.data.data);
            location.reload()
          }else {
            this.$message.error(data.data.message)
          }
        });
        // utils.setStorage('user',{id:1,username:"张三",psw:"123",user_phone:"13112341234",sex:0,birthday:"2001-02-23T13:14",email:"1875@qq.com",
        //   login_time:"2021-02-23T13:14",
        //   header_img:"https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=1680232936,3689011600&fm=11&gp=0.jpg"});
        // location.reload()
      },
      //登录
      /*重置*/
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.codeNum=null
      },
      regiserFinish(value){
        console.log(value)
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.axios({
              url:'/verifyPost',
              method:'post',
              data:{
                username:this.formRegiser.username,
                user_phone:this.formRegiser.user_phone,
                password:this.formRegiser.pass
              }
            }).then(data=>{
              console.log(data);
              if (data.data.code === 200){
                this.$message({
                  message:data.data.message,
                  type: 'success'
                });
                utils.setStorage('user',this.formRegiser);
              }else {
                this.$message.error(data.data.message)
              }
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      code(){
        this.codeNum=Math.floor(Math.random()*(9999-1000))+1000;
      }
    },
    created() {
      if (utils.getStorage("user")){
        setTimeout(()=>{
          this.$router.push({
            path: '/home/main',
          })
        },100)
      }
    }
  }
</script>

<style lang="less" scoped>
  .beijing{
    background-image: url('https://th.bing.com/th/id/Rd52bd6d26ca8f5074a0c4bc71434a982?rik=2rUCeSMX5FP%2bnA&riu=http%3a%2f%2fimg18.3lian.com%2fd%2ffile%2f201711%2f01%2f5fdf40b537a753a87d3084907a17e00e.jpg&ehk=RSflVEgcDKM0qLgw%2ftwkmJu%2fh%2f04BV6LvNwBHew56jc%3d&risl=&pid=ImgRaw');
    margin: 0;
    padding: 0;
    background-size: 100%;
    height: 100vh;
    position:relative;
  }
  .denglu{
    position: absolute;
    top: 7rem;
    left: 45rem;
    text-align: center;
    padding: 3rem;
    width: 40rem;
    background-color: rgba(255, 255, 255, 0.75);
    display: flex;
    justify-content: center;
  }
  element.style {
    margin-left: 5rem;
  }
  .code{
    display: inline-block;
    background-image: url('https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=4093928608,85355382&fm=26&gp=0.jpg');
    margin-left:1.8rem;
    width: 10rem;
    height: 3.25rem;
    line-height: 3rem;
    border-radius: 0.5rem
  }
</style>